import {StepDto} from "../dto/step-dto";

export enum StepType {
  REFERENCE = 'REFERENCE',
  WEAR = 'WEAR'
}

export enum TyrePositionDto {
  FRONT_LEFT = 'FRONT_LEFT',
  FRONT_RIGHT = 'FRONT_RIGHT',
  REAR_RIGHT = 'REAR_RIGHT',
  REAR_LEFT = 'REAR_LEFT'
}

export class Step {
  position: number;
  type: StepType;

  constructor(position: number, type: StepType) {
    this.position = position;
    this.type = type;
  }

  toString() {
    return this.position + '_' + this.type;
  }

  static fromString(stepAsString: string) {
    return new Step(+this.isolatePositionFromStep(stepAsString),
      this.isolateTypeFromStep(stepAsString) as StepType);
  }

  static getTyrePositionDto(position: number): TyrePositionDto {
    switch (position) {
      case 1: return TyrePositionDto.FRONT_LEFT;
      case 2: return TyrePositionDto.FRONT_RIGHT;
      case 3: return TyrePositionDto.REAR_RIGHT;
      case 4: return TyrePositionDto.REAR_LEFT;
      default: throw new Error(`Unsupported tyre position: ${position}`);
    }
  }

  static getPositionFromTyrePositionDto(position: TyrePositionDto): number {
    switch (position) {
      case TyrePositionDto.FRONT_LEFT: return 1;
      case TyrePositionDto.FRONT_RIGHT: return 2;
      case TyrePositionDto.REAR_RIGHT: return 3;
      case TyrePositionDto.REAR_LEFT: return 4;
      default: throw new Error(`Unsupported tyre position: ${position}`);
    }
  }

  static getPositionFromStepDto(stepDto: StepDto): number {
    let position = -1;
    switch (stepDto) {
      case StepDto.LEFT_FRONT: position = 1; break;
      case StepDto.RIGHT_FRONT: position = 2; break;
      case StepDto.RIGHT_REAR: position = 3; break;
      case StepDto.LEFT_REAR: position = 4; break;
    }
    return position;
  }

  private static isolateTypeFromStep(step: string): StepType {
    const type: string = step ? step.split('_').slice(1).join('_') : '';
    return StepType[type as keyof typeof StepType];
  }

  private static isolatePositionFromStep(step: string) {
    return step ? step.split('_')[0] : '';
  }
}
